import React from 'react';
// import gif from '../../Images/loader.gif'
import gif from '../Loading/imgpsh_fullsize_anim.gif'
const Loading = ({status}) => {
  return (
    <div id="preloader">
      <img src={gif}/>
      </div>
  );
};

export default Loading;
